import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AuthWrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #181c21;
  color: #fff;
  position: relative;

  .loader {
    margin-top: 20px;
  }
  .login-message {
    font-weight: 500;
    font-size: 17px;
  }
  .auth-successfully {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .user-name {
      font-size: 18px;
      font-weight: 500;
      color: #d9d9d9;
    }
    .welcome-message {
      font-size: 20px;
      font-weight: 500;
      color: #fcd839;
    }
    .success-message {
      color: #d9d9d9;
      font-weight: 400;
      font-size: 14px;
    }
  }

  .logged-out {
    color: #fff;
    opacity: 0.5;
    margin: 20px 0;
    width: 50%;
    text-align: center;
  }
  .btn-logged_out {
    z-index: 999;
  }

  .tower-pc__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 20px;
    .select-user {
      width: 250px;
    }
  }
`;
